import React, { Suspense, useEffect, useState } from 'react';
import bem from 'utils/bem';
import { observer } from 'mobx-react-lite';
import { useMobile } from 'utils/media';
import DatetimeField from 'forms/fields/DatetimeField';
import CommonDateTimeInput from 'forms/fields/DatetimeField/CommonDateTimeInput';
import MobileDialogDateTimeField from 'forms/fields/DatetimeField/MobileDialogDateTimeField';
import PopoverDateTimeField from 'forms/fields/DatetimeField/PopoverDateTimeField';
import Model from '../../../../../model';
import { specialistEventsData } from 'api/events';
import './index.sass';

const { block, el } = bem('transfer-form-events-field');

const MobilePopup = (props) => {
    const text = 'Выберите желаемую дату и время';
    return <MobileDialogDateTimeField {...props} text={text} />
}

const EventsField = ({specId, meetingType, setEventPK}) => {

    const resource = specialistEventsData({specialist: specId, meeting: meetingType});

    return (
        <div className={ block() }>
            <Suspense fallback={<CommonDateTimeInput loading={true} />}>
                <SuspendedDatetimeField resource={resource} meetingType={meetingType} setEventPK={setEventPK}/>
            </Suspense>
        </div>
    );
}

const SuspendedDatetimeField = observer(({resource, meetingType, setEventPK}) => {
    const events = resource.read();
    const { isMobile } = useMobile();
    const filteredEvents = events.filter(event => event.service.meetingType === meetingType);
    const utcDates = filteredEvents.map(event => event.startDate);
    const closestEvent = Model.events._findClosestEvent(utcDates);
    const [ value, setValue ] = useState(closestEvent);

    useEffect(() => {
        if (value) {
            const event = filteredEvents.find(e => e.startDate === value);
            if (event) {
                const pk = event.pk;
                setEventPK(pk);
            } else {
                setEventPK(null);
            }
        } else {
            setEventPK(value);
        }

    }, [ value ]);

    return <DatetimeField name={ 'datetime-field' } setValue={ setValue } Input={ CommonDateTimeInput }
                            Popup={ isMobile ? MobilePopup : PopoverDateTimeField }
                            utcDates={ utcDates } value={ value } />
})

export default observer(EventsField);
